var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('master-details-component',{attrs:{"headers":_vm.headers,"tableData":_vm.getTableData,"component":'ApplicantRequestComponent'}})}
var staticRenderFns = []

export { render, staticRenderFns }